var storage = {
	set(key, value, timeout = 0) {
		if (timeout > 0) {
			let valueObj = {
				"value": value,
				"timeOut": timeout*1000, //秒数
				"setTime": new Date().getTime()
			};
			localStorage.setItem(key, JSON.stringify(valueObj));
		} else {
			localStorage.setItem(key, JSON.stringify(value));
		}
	},
	get(key) {
		let item = localStorage.getItem(key);
		if (this.isJSON(item)) {
			let newItem = JSON.parse(item);
			if (newItem.timeOut) {
				let currentTime = new Date().getTime();
				if (currentTime - newItem.setTime > newItem.timeOut) {
					localStorage.removeItem(key);
					return false;
				} else {
					return newItem;
				}
			} else {
				return newItem;
			}
			//return JSON.parse(item);
		} else if (item == null) {
			return '';
		} else if (item != null) {
			// return item.replaceAll('"','');
			return item.replace(/"/g, '');
		}
		//return this.isJSON(item) ? JSON.parse(item) : item.replaceAll('"','');
	},
	remove(key) {
		localStorage.removeItem(key)
	},
	isJSON(str) {
		if (typeof str == 'string') {
			try {
				var obj = JSON.parse(str);
				if (typeof obj == 'object' && obj) {
					return true;
				} else {
					return false;
				}
			} catch (e) {
				return false;
			}
		}
	}
}
export default storage;
